import FullScreenContainer from "../../components/FullScreenContainer";
import { Helmet } from "react-helmet";
import Button from "../../components/ui-lib/buttons/Button";
import start_parallax from "./../../images/start_parallax.png";
import h2 from "./../../images/h2.png";
import jederzeit from "./../../images/jederzeit.png";
import school from "./../../images/School.png";
import einerAlle from "./../../images/einerfüralleallefüreinen.png";
import conn from "./../../images/mehrConnection.png";
import inff from "./../../images/informationsfluss.png";
import top from "./../../images/Top.png";
import useParallax from "../../hooks/useParallax";
import AutoPlayVideo from "../../components/ui-lib/videoplayer";

function Home() {
  const parallaxStyle = useParallax(start_parallax);

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Wir bieten ein nahtloses und schulübergreifendes Vertretungssystem für Schulen und Lehrpersonen."
        />
        <title>Nidesso | Das nahtlose Vertretungssystem für Schulen.</title>
      </Helmet>
      <FullScreenContainer
        centerContent={true}
        style={parallaxStyle}
        className="bg-th-accent-50 bg-center bg-no-repeat scroll-smooth"
      >
        <div
          className="
          max-w-[80%]
          font-sans
          sm:max-w-[50%]
          "
        >
          <h1
            className="
            mb-4 text-2xl font-bold text-[#000000]
            sm:text-2xl
            md:text-4xl
            lg:text-4xl
            xl:text-4xl   
            "
          >
            Wir bauen Ihr wirksames Vertretungssystem
          </h1>
          <p>Melde Sie sich jetzt für eine Vorstellung!</p>
          <div className="mt-4">
            <Button
              className="mx-auto mt-4 block"
              theme="primary"
              onClick={() => {
                window.location.href = "mailto:info@nidesso.ch";
              }}
            >
              Demo vereinbaren!
            </Button>
          </div>
        </div>
      </FullScreenContainer>

      <FullScreenContainer
        centerContent={true}
        className="bg-th-secondary-900 bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${h2})`,
          backgroundSize: "auto calc(var(--viewportHeight) + 2px)",
        }}
      >
        <div className="flex w-full flex-col items-center font-sans">
          <h2
            className="w-full text-3xl text-white
                    sm:text-4xl
                    md:text-4xl
                    lg:text-5xl
                    xl:text-5xl
                    "
          >
            Unsere Mission
          </h2>{" "}
          <br />
          <p
            style={{ lineHeight: "1.2" }}
            className="w-[80%] text-2xl text-white
                    sm:w-[70%]
                    sm:text-3xl
                    md:w-[60%]
                    md:text-3xl
                    lg:w-[55%]
                    lg:text-3xl
                    xl:w-[55%]
                    xl:text-3xl
                    "
          >
            "Unsere Mission ist es, Schulen mit einem nahtlosen und
            schulübergreifenden Vertretungssystem zu unterstützen, damit keine
            Lektion mehr ausfallen muss."
          </p>
        </div>
      </FullScreenContainer>

      <FullScreenContainer
        className="bg-th-accent-50 bg-center bg-no-repeat"
        centerContent={true}
      >
        <div className="my-auto flex flex-col items-center font-sans">
          <h2
            className="mt-8 w-full p-4 text-2xl text-[#929ED8]
                    sm:w-full
                    sm:text-3xl
                    md:w-full
                    md:text-3xl
                    lg:w-full
                    lg:text-3xl
                    xl:w-full
                    xl:text-4xl
                    "
          >
            Herausforderungen, die wir lösen können.
          </h2>
          <div className="sm: grid gap-4 p-5 md:grid md:grid-cols-3">
            <div className="rounded-lg bg-white p-5 shadow-lg">
              <div className="mb-4 flex flex-col items-center">
                <p className="mb-2 mt-10 text-center font-bold text-gray-800">
                  "Meine Vertretungsliste ist einfach zu kurz für die vielen
                  Ausfälle."
                </p>
                <p className="mt-10 text-center text-gray-800">
                  Sabine, <br></br>Schulleiterin
                </p>
              </div>
            </div>
            <div className="rounded-lg bg-white p-5 shadow-lg">
              <div className="mb-4">
                <p className="mb-2 mt-10 font-bold text-gray-800">
                  "Ich teile die SuS ungern auf andere Klassen auf aber so
                  kurzfristig kann ich keine Vertretung finden!"
                </p>
                <p className="mt-10 text-gray-800">
                  Claudio, <br></br>Schulleiter
                </p>
              </div>
            </div>
            <div className="rounded-lg bg-white p-5 shadow-lg">
              <div className="mb-4">
                <p className="mb-2 mt-10 font-bold text-gray-800">
                  "Ich liege krank im Bett und muss noch eine Vertretung
                  organisieren."
                </p>
                <p className="mt-10 text-gray-800">
                  Arian, <br></br>Klassenlehrer
                </p>
              </div>
            </div>
            <div className="rounded-lg bg-white p-5 shadow-lg">
              <div className="mb-4">
                <p className="mb-2 mt-10 font-bold text-gray-800">
                  "20:00 Uhr und ich muss mit unserem Lehrerteam eine Vertretung
                  für den morgigen Tag ausmachen."
                </p>
                <p className="mt-10 text-gray-800">
                  Lisa, <br></br>Schulleiterin
                </p>
              </div>
            </div>
            <div className="rounded-lg bg-white p-5 shadow-lg">
              <div className="mb-4">
                <p className="mb-2 mt-10 font-bold text-gray-800">
                  "Telefon, Emails, WhatsApp, Plattformen und so weiter! Ich
                  habe keine Zeit, unsere Vertretungssuche über all diese Kanäle
                  zu führen."
                </p>
                <p className="mt-10 text-gray-800">
                  Jürgen, <br></br>Schulleiter
                </p>
              </div>
            </div>
            <div className="rounded-lg bg-white p-5 shadow-lg">
              <div className="mb-4">
                <p className="mb-2 mt-10 font-bold text-gray-800">
                  "Im Winter hat unser Schulkreis so viele Ausfälle, dass wir
                  Stunden in das Erfassen und Führen der Vertretungsstellen
                  investieren müssen."
                </p>
                <p className="mt-10 text-gray-800">
                  Mirjam & Moni, <br></br>Schulsekretariat
                </p>
              </div>
            </div>
          </div>
        </div>
      </FullScreenContainer>

      <FullScreenContainer
        centerContent={true}
        className="relative bg-th-secondary-900 bg-center bg-no-repeat"
      >
        <div className="absolute top-9 w-full pt-10 font-sans">
          <h2 className="m-auto w-[80%] text-center text-4xl text-white">
            Der gesamte Prozess in einer Lösung.
          </h2>
        </div>
        <div className="absolute flex w-full items-center justify-center">
          <svg
            className="sm:hidden"
            overflow="visible"
            width="334"
            height="1800"
            viewBox="0 0 334 1400"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M295.131 2.73892L293.162 0.476047L288.636 4.41529L290.606 6.67816L295.131 2.73892ZM277.687 158.223L311.003 148.733L286.127 124.626L277.687 158.223ZM297.791 15.2355L299.676 17.5698L304.345 13.8011L302.46 11.4668L297.791 15.2355ZM315.839 29.8963L314.23 27.3642L309.166 30.582L310.774 33.1141L315.839 29.8963ZM320.733 52.5406L321.79 55.348L327.405 53.2332L326.348 50.4257L320.733 52.5406ZM330.982 73.3519L330.925 70.3524L324.927 70.4663L324.983 73.4657L330.982 73.3519ZM321.365 94.4304L320.35 97.2537L325.997 99.2826L327.011 96.4593L321.365 94.4304ZM316.519 117.036L318.151 114.519L313.117 111.254L311.485 113.772L316.519 117.036ZM298.237 131.474L296.313 133.775L300.917 137.623L302.841 135.321L298.237 131.474ZM287.712 152.189L289.778 150.013L285.427 145.882L283.361 148.058L287.712 152.189ZM290.606 6.67816C293.148 9.59881 295.542 12.4492 297.791 15.2355L302.46 11.4668C300.16 8.6174 297.718 5.71011 295.131 2.73892L290.606 6.67816ZM310.774 33.1141C315.113 39.9415 318.411 46.3756 320.733 52.5406L326.348 50.4257C323.852 43.7998 320.35 36.9962 315.839 29.8963L310.774 33.1141ZM324.983 73.4657C325.116 80.4571 323.903 87.3656 321.365 94.4304L327.011 96.4593C329.772 88.7754 331.13 81.1418 330.982 73.3519L324.983 73.4657ZM311.485 113.772C307.806 119.444 303.387 125.313 298.237 131.474L302.841 135.321C308.105 129.023 312.678 122.959 316.519 117.036L311.485 113.772Z"
              fill="#D9D8DD"
            />
            <path
              d="M295.96 737.208L293.991 734.945L289.465 738.884L291.435 741.147L295.96 737.208ZM278.516 892.692L311.832 883.202L286.956 859.095L278.516 892.692ZM298.621 749.704L300.505 752.039L305.174 748.27L303.289 745.936L298.621 749.704ZM316.668 764.365L315.059 761.833L309.995 765.051L311.604 767.583L316.668 764.365ZM321.562 787.009L322.619 789.817L328.234 787.702L327.177 784.894L321.562 787.009ZM331.811 807.821L331.755 804.821L325.756 804.935L325.813 807.934L331.811 807.821ZM322.194 828.899L321.179 831.722L326.826 833.751L327.84 830.928L322.194 828.899ZM317.348 851.505L318.98 848.988L313.946 845.723L312.314 848.24L317.348 851.505ZM299.066 865.942L297.143 868.244L301.746 872.092L303.67 869.79L299.066 865.942ZM288.541 886.658L290.607 884.482L286.256 880.351L284.19 882.526L288.541 886.658ZM291.435 741.147C293.977 744.068 296.371 746.918 298.621 749.704L303.289 745.936C300.989 743.086 298.547 740.179 295.96 737.208L291.435 741.147ZM311.604 767.583C315.942 774.41 319.24 780.844 321.562 787.009L327.177 784.894C324.681 778.269 321.179 771.465 316.668 764.365L311.604 767.583ZM325.813 807.934C325.945 814.926 324.732 821.834 322.194 828.899L327.84 830.928C330.601 823.244 331.959 815.611 331.811 807.821L325.813 807.934ZM312.314 848.24C308.635 853.913 304.216 859.781 299.066 865.942L303.67 869.79C308.934 863.492 313.507 857.427 317.348 851.505L312.314 848.24Z"
              fill="#D9D8DD"
            />
            <path
              d="M297.96 1471.21L295.991 1468.94L291.465 1472.88L293.435 1475.15L297.96 1471.21ZM280.516 1626.69L313.832 1617.2L288.956 1593.09L280.516 1626.69ZM300.621 1483.7L302.505 1486.04L307.174 1482.27L305.289 1479.94L300.621 1483.7ZM318.668 1498.37L317.059 1495.83L311.995 1499.05L313.604 1501.58L318.668 1498.37ZM323.562 1521.01L324.619 1523.82L330.234 1521.7L329.177 1518.89L323.562 1521.01ZM333.811 1541.82L333.755 1538.82L327.756 1538.94L327.813 1541.93L333.811 1541.82ZM324.194 1562.9L323.179 1565.72L328.826 1567.75L329.84 1564.93L324.194 1562.9ZM319.348 1585.5L320.98 1582.99L315.946 1579.72L314.314 1582.24L319.348 1585.5ZM301.066 1599.94L299.143 1602.24L303.746 1606.09L305.67 1603.79L301.066 1599.94ZM290.541 1620.66L292.607 1618.48L288.256 1614.35L286.19 1616.53L290.541 1620.66ZM293.435 1475.15C295.977 1478.07 298.371 1480.92 300.621 1483.7L305.289 1479.94C302.989 1477.09 300.547 1474.18 297.96 1471.21L293.435 1475.15ZM313.604 1501.58C317.942 1508.41 321.24 1514.84 323.562 1521.01L329.177 1518.89C326.681 1512.27 323.179 1505.46 318.668 1498.37L313.604 1501.58ZM327.813 1541.93C327.945 1548.93 326.732 1555.83 324.194 1562.9L329.84 1564.93C332.601 1557.24 333.959 1549.61 333.811 1541.82L327.813 1541.93ZM314.314 1582.24C310.635 1587.91 306.216 1593.78 301.066 1599.94L305.67 1603.79C310.934 1597.49 315.507 1591.43 319.348 1585.5L314.314 1582.24Z"
              fill="#D9D8DD"
            />
            <path
              d="M28.0407 1136.69L29.8738 1134.31L34.6234 1137.98L32.7903 1140.35L28.0407 1136.69ZM41.2754 1268.69L8.60431 1257.18L34.9124 1234.64L41.2754 1268.69ZM27.3085 1147.71L25.5628 1150.15L20.6833 1146.66L22.4291 1144.22L27.3085 1147.71ZM12.2603 1160.03L13.7323 1157.41L18.9604 1160.36L17.4884 1162.97L12.2603 1160.03ZM10.0552 1179.28L9.09769 1182.12L3.41147 1180.21L4.36894 1177.37L10.0552 1179.28ZM0.817926 1196.36L0.906318 1193.36L6.90371 1193.54L6.81532 1196.54L0.817926 1196.36ZM9.17595 1213.84L10.0354 1216.72L4.28689 1218.44L3.42744 1215.56L9.17595 1213.84ZM11.0515 1233.1L9.58551 1230.48L14.8203 1227.55L16.2863 1230.17L11.0515 1233.1ZM26.1958 1245.36L27.9695 1247.78L23.1305 1251.33L21.3568 1248.91L26.1958 1245.36ZM32.9371 1263.57L31.0097 1261.27L35.6075 1257.42L37.5349 1259.71L32.9371 1263.57ZM32.7903 1140.35C30.8496 1142.87 29.0229 1145.32 27.3085 1147.71L22.4291 1144.22C24.1895 1141.76 26.0597 1139.25 28.0407 1136.69L32.7903 1140.35ZM17.4884 1162.97C14.2599 1168.7 11.7981 1174.11 10.0552 1179.28L4.36894 1177.37C6.25339 1171.77 8.88318 1166.02 12.2603 1160.03L17.4884 1162.97ZM6.81532 1196.54C6.64469 1202.33 7.4383 1208.03 9.17595 1213.84L3.42744 1215.56C1.51946 1209.18 0.627064 1202.84 0.817926 1196.36L6.81532 1196.54ZM16.2863 1230.17C19.0116 1235.03 22.3169 1240.07 26.1958 1245.36L21.3568 1248.91C17.3696 1243.47 13.9225 1238.23 11.0515 1233.1L16.2863 1230.17Z"
              fill="#D9D8DD"
            />
            <path
              d="M28.4279 407.302L30.4511 405.087L34.8814 409.133L32.8582 411.348L28.4279 407.302ZM42.297 519.693L8.78954 510.903L33.1549 486.28L42.297 519.693ZM25.7921 419.474L23.8866 421.791L19.2524 417.98L21.1579 415.663L25.7921 419.474ZM8.41406 434.06L9.84813 431.425L15.1182 434.293L13.6841 436.928L8.41406 434.06ZM7.35345 456.363L7.10717 459.352L1.12742 458.86L1.37371 455.87L7.35345 456.363ZM5.56085 478.575L4.34105 475.835L9.82268 473.395L11.0425 476.136L5.56085 478.575ZM22.2837 493.882L24.1512 496.23L19.4556 499.965L17.5881 497.617L22.2837 493.882ZM32.3921 514.111L30.2902 511.971L34.5713 507.767L36.6732 509.908L32.3921 514.111ZM32.8582 411.348C30.3035 414.145 27.9497 416.85 25.7921 419.474L21.1579 415.663C23.3896 412.949 25.8125 410.165 28.4279 407.302L32.8582 411.348ZM13.6841 436.928C9.8937 443.893 7.85588 450.263 7.35345 456.363L1.37371 455.87C1.95951 448.758 4.32045 441.582 8.41406 434.06L13.6841 436.928ZM11.0425 476.136C13.547 481.763 17.2893 487.603 22.2837 493.882L17.5881 497.617C12.3898 491.082 8.33366 484.806 5.56085 478.575L11.0425 476.136Z"
              fill="#D9D8DD"
            />
          </svg>

          <svg
            className="
              mr-10
              mt-20 hidden
              sm:block
              sm:w-16
              md:w-20 
              lg:w-28"
            viewBox="-20 -30 116 2000"
            overflow="visible"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M114 1C114 1 24.8958 193.247 16.5001 305C7.34375 426.879 125.709 548.84 114 670.5C102.317 791.9 12.4887 810.835 4.00025 932.5C-5.49182 1068.55 107.887 1146.76 114 1283C119.616 1408.16 13.6579 1495.76 2.00005 1620.5C-11.0373 1760 69.5001 2039 69.5001 2039"
              stroke="white"
              strokeWidth="5"
              strokeDasharray="30 20"
            />
            <polygon points="95,-6 130,6 100,33" fill="#FE9456" />
            <circle cx="38" cy="200" r="20" fill="#929ED8" />
            <circle cx="105" cy="582" r="20" fill="#929ED8" />
            <circle cx="4" cy="956" r="20" fill="#929ED8" />
            <circle cx="113" cy="1285" r="20" fill="#929ED8" />
            <circle cx="3" cy="1615" r="20" fill="#929ED8" />
            <circle cx="47" cy="1956" r="20" fill="#929ED8" />
          </svg>
        </div>

        <div
          className="flex w-full flex-col items-center pb-0 pt-20 font-sans"
          style={{ marginTop: "150px", zIndex: "10" }}
        >
          {" "}
          {}
          <div
            className="
            mb-0 flex w-full flex-col justify-center
            sm:flex-row
            md:flex-row
            lg:flex-row"
          >
            <div className="flex-1 text-center"></div>
            <div
              className="mb-24 flex-1 flex-grow text-center
              sm:mb-0
              md:mb-0
              lg:mb-0"
            >
              <div className="relative flex w-full items-center justify-center">
                <div className="mr-3 flex w-full flex-col items-center">
                  <img
                    className="mt-0 max-w-28
                    sm:ml-10
                    sm:max-w-24
                    md:ml-0
                    md:max-w-32
                    lg:ml-0
                    lg:max-w-48"
                    src={jederzeit}
                    alt="Jederzeit"
                  />
                  <h2
                    className="
                    mt-2 text-xs text-black
                    sm:ml-10 
                    sm:text-sm
                    md:ml-0
                    md:text-base
                    lg:ml-0
                    lg:text-xl"
                  >
                    Ausfälle jederzeit schnell erfassen
                  </h2>
                  <p
                    className="
                    mr-4 mt-3 max-w-52 text-xs text-black
                    sm:ml-10
                    sm:w-full 
                    sm:max-w-56
                    sm:text-xs
                    md:ml-0
                    md:max-w-60
                    md:text-xs
                    lg:ml-0
                    lg:max-w-80
                    lg:text-base"
                  >
                    Lehrpersonen können jederzeit über die Nidesso
                    <a
                      href="#ausfallerfassung"
                      className="font-bold text-[#FE9456] hover:text-[#FFAC7B] "
                    >
                      {" "}
                      Ausfallerfassung{" "}
                    </a>
                    Abwesenheiten erfassen. Diese werden direkt im System
                    hinterlegt und sowohl der Schulleitung / Verwaltung als auch
                    dem Lehrkollegium mitgeteilt.
                  </p>
                </div>
                <svg
                  className="
                  absolute -z-10 mb-2 mr-0 max-w-72 rotate-0
                  sm:ml-10
                  sm:mr-4
                  sm:max-w-72
                  md:ml-0
                  md:mr-4
                  md:max-w-80
                  lg:ml-0
                  lg:mr-4
                  lg:max-w-full"
                  height="450"
                  overflow={"visible"}
                  viewBox="0 0 462 450"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M391.703 84.0527C477.211 155.803 485.706 286.454 410.676 375.87C335.647 465.287 142.389 515.647 56.8809 443.897C-28.6272 372.147 -9.635 136.253 65.3944 46.8366C140.424 -42.58 306.195 12.3029 391.703 84.0527Z"
                    fill="#F0EFF4"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div
            className="
            mb-4 flex w-full flex-col justify-center
            sm:flex-row
            md:flex-row
            lg:flex-row"
          >
            <div
              className="mb-24 flex-1 flex-grow text-center
              sm:mb-0
              md:mb-0
              lg:mb-0"
            >
              <div className="relative flex w-full items-center justify-center">
                <div className="mr-3 flex w-full flex-col items-center">
                  <img
                    className="mt-0 max-w-28
                    sm:max-w-24
                    md:max-w-32
                    lg:max-w-48"
                    src={school}
                    alt=" Reibungslose Koordination in den eigenen vier Wänden"
                  />
                  <h2
                    className="
                    mt-2 text-xs text-black
                    sm:text-sm 
                    md:text-base
                    lg:text-xl"
                  >
                    Reibungslose Koordination in den <br></br>
                    eigenen vier Wänden{" "}
                  </h2>
                  <p
                    className="
                    mt-3 max-w-44 text-xs text-black
                    sm:max-w-52
                    sm:text-xs 
                    md:max-w-60
                    md:text-xs
                    lg:max-w-96
                    lg:text-base"
                  >
                    Der
                    <a
                      href="#vertretungsmoderator"
                      className="font-bold text-[#FE9456] hover:text-[#FFAC7B] "
                    >
                      {" "}
                      Vertretungsmoderator{" "}
                    </a>
                    von Nidesso unterstützt Ihr Lehrerteam bei der Kommunikation
                    und Koordination für eine rasche und optimale Aufteilung der
                    ausfallenden Lektionen.
                  </p>
                </div>
                <svg
                  className="
                    rotate-30 absolute -z-10 max-w-72
                    sm:max-w-72
                    md:max-w-80
                    lg:max-w-full"
                  height="450"
                  overflow="visible"
                  viewBox="0 0 462 450"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M391.703 84.0527C477.211 155.803 485.706 286.454 410.676 375.87C335.647 465.287 142.389 515.647 56.8809 443.897C-28.6272 372.147 -9.635 136.253 65.3944 46.8366C140.424 -42.58 306.195 12.3029 391.703 84.0527Z"
                    fill="#F0EFF4"
                  />
                </svg>
              </div>
            </div>
            <div className="flex-1 text-center"></div>
          </div>
          <div
            className="
            mb-6 flex w-full flex-col justify-center
            sm:flex-row
            md:flex-row
            lg:flex-row"
          >
            <div className="flex-1 text-center"></div>
            <div
              className="mb-24 flex-1 flex-grow text-center
              sm:mb-0
              md:mb-0
              lg:mb-0"
            >
              <div className="relative flex w-full items-center justify-center">
                <div className="mr-3 flex w-full flex-col items-center">
                  <img
                    className="mt-0 max-w-28
                    sm:max-w-24
                    md:max-w-32
                    lg:max-w-48"
                    src={einerAlle}
                    alt="Einer für alle, alle für einen"
                  />
                  <h2
                    className="
                    mt-2 text-xs text-black
                    sm:text-sm 
                    md:text-base
                    lg:text-xl"
                  >
                    Einer für alle, alle für einen
                  </h2>
                  <p
                    className="
                    mt-3 max-w-44 text-xs text-black
                    sm:max-w-52
                    sm:text-xs 
                    md:max-w-60
                    md:text-xs
                    lg:max-w-96
                    lg:text-base"
                  >
                    Anstelle dass jede Schule die eigene Vertretungsliste
                    verwaltet, sorgen die Schulen gemeinsam für ein
                    übergreifendes Vertretungs-Netzwerk.
                  </p>
                </div>
                <svg
                  className="
                  absolute -z-10 max-w-72 rotate-0 
                  sm:max-w-72
                  md:max-w-80
                  lg:max-w-full"
                  height="450"
                  overflow="visible"
                  viewBox="0 0 462 450"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M391.703 84.0527C477.211 155.803 485.706 286.454 410.676 375.87C335.647 465.287 142.389 515.647 56.8809 443.897C-28.6272 372.147 -9.635 136.253 65.3944 46.8366C140.424 -42.58 306.195 12.3029 391.703 84.0527Z"
                    fill="#F0EFF4"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div
            className="
            mb-10 flex w-full flex-col justify-center
            sm:flex-row
            md:flex-row
            lg:flex-row"
          >
            <div
              className="mb-24 flex-1 flex-grow text-center
              sm:mb-0
              md:mb-0
              lg:mb-0"
            >
              <div className="relative flex w-full items-center justify-center">
                <div className="mr-3 flex w-full flex-col items-center">
                  <img
                    className="mt-0 max-w-28
                    sm:max-w-24
                    md:max-w-32
                    lg:max-w-48"
                    src={conn}
                    alt="Erhöhung der Reichweite"
                  />
                  <h2
                    className="
                    mt-2 text-xs text-black
                    sm:text-sm 
                    md:text-base
                    lg:text-xl"
                  >
                    Erhöhung der Reichweite
                  </h2>
                  <p
                    className="
                    mt-3 max-w-44 text-xs text-black
                    sm:max-w-52
                    sm:text-xs 
                    md:max-w-60
                    md:text-xs
                    lg:max-w-96
                    lg:text-base"
                  >
                    Die Nidesso
                    <a
                      href="#vermittlungsplattform"
                      className="font-bold text-[#FE9456] hover:text-[#FFAC7B] "
                    >
                      {" "}
                      Vermittlungsplattform{" "}
                    </a>
                    hilft Ihnen bei der Suche von passenden
                    Vertretungslehrpersonen. Um Ihre Reichweite zu erhöhen,
                    sorgt Nidesso für eine grossflächige Publizierung.
                  </p>
                </div>
                <svg
                  className="
                    absolute -z-10 max-w-72 rotate-0 
                    sm:max-w-72
                    md:max-w-80
                    lg:max-w-full"
                  height="450"
                  overflow="visible"
                  viewBox="0 0 462 450"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M391.703 84.0527C477.211 155.803 485.706 286.454 410.676 375.87C335.647 465.287 142.389 515.647 56.8809 443.897C-28.6272 372.147 -9.635 136.253 65.3944 46.8366C140.424 -42.58 306.195 12.3029 391.703 84.0527Z"
                    fill="#F0EFF4"
                  />
                </svg>
              </div>
            </div>
            <div className="flex-1 text-center"></div>
          </div>
          <div
            className="
            mb-0 flex w-full flex-col justify-center
            sm:flex-row
            md:flex-row
            lg:flex-row"
          >
            <div className="flex-1 text-center"></div>
            <div
              className="mb-24 flex-1 flex-grow text-center
              sm:mb-0
              md:mb-0
              lg:mb-0"
            >
              <div className="relative flex w-full items-center justify-center">
                <div className="mr-3 flex w-full flex-col items-center">
                  <img
                    className="mt-0 max-w-28
                    sm:ml-0
                    sm:max-w-24
                    md:ml-0
                    md:max-w-32
                    lg:ml-10
                    lg:max-w-48"
                    src={inff}
                    alt="Einen klareren Informationsfluss"
                  />
                  <h2
                    className="
                    mt-2 text-xs text-black
                    sm:ml-0 
                    sm:text-sm
                    md:ml-0
                    md:text-base
                    lg:ml-10
                    lg:text-xl"
                  >
                    Einen klareren Informationsfluss
                  </h2>
                  <p
                    className="
                    mt-3 max-w-44 text-xs text-black
                    sm:ml-0
                    sm:max-w-52
                    sm:text-xs 
                    md:ml-0
                    md:max-w-60
                    md:text-xs
                    lg:ml-10
                    lg:max-w-96
                    lg:text-base"
                  >
                    Sowohl die Schulleitung als auch die ausfallende Lehrperson
                    haben die Möglichkeit, wichtige Informationen und auch
                    Dokumente bei den Vertretungsstellen zu hinterlegen.
                  </p>
                </div>
                <svg
                  className="
                    absolute -z-10 max-w-72 rotate-0 
                    sm:ml-0
                    sm:max-w-72
                    md:ml-0
                    md:max-w-80
                    lg:ml-10
                    lg:max-w-full"
                  height="450"
                  overflow="visible"
                  viewBox="0 0 462 450"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M391.703 84.0527C477.211 155.803 485.706 286.454 410.676 375.87C335.647 465.287 142.389 515.647 56.8809 443.897C-28.6272 372.147 -9.635 136.253 65.3944 46.8366C140.424 -42.58 306.195 12.3029 391.703 84.0527Z"
                    fill="#F0EFF4"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div
            className="
            mb-0 flex w-full flex-col justify-center
            sm:flex-row
            md:flex-row
            lg:flex-row"
          >
            <div
              className="mb-0 flex-1 flex-grow text-center
              sm:mb-0
              md:mb-0
              lg:mb-0"
            >
              <div className="relative flex w-full items-center justify-center">
                <div className="mr-3 flex w-full flex-col items-center">
                  <img
                    className="mt-0 max-w-24
                    sm:mr-10
                    sm:max-w-20
                    md:mr-10
                    md:max-w-28
                    lg:mr-20
                    lg:max-w-40"
                    src={top}
                    alt="Alles jederzeit im Überblick"
                  />
                  <h2
                    className="
                    mt-2 text-xs text-black
                    sm:mr-10
                    sm:text-sm
                    md:mr-10
                    md:text-base
                    lg:mr-24
                    lg:text-xl"
                  >
                    Alles jederzeit im Überblick
                  </h2>
                  <p
                    className="
                    mt-3 max-w-44 text-xs text-black
                    sm:mr-10
                    sm:max-w-52
                    sm:text-xs
                    md:mr-10
                    md:max-w-60
                    md:text-xs
                    lg:mr-24
                    lg:max-w-96
                    lg:text-base"
                  >
                    Der
                    <a
                      href="#vertretungsmanager "
                      className="font-bold text-[#FE9456] hover:text-[#FFAC7B] "
                    >
                      {" "}
                      Vertretungsmanager{" "}
                    </a>
                    von Nidesso ermöglicht es Ihnen jederzeit sämtliche Ihrer
                    Vertretungsstellen zu überwachen und hält sie stetig über
                    Änderungen und Bewerbungen auf dem laufenden.
                  </p>
                </div>
                <svg
                  className="
                    absolute -z-10 max-w-72 rotate-0 
                    sm:mr-10
                    sm:max-w-72
                    md:mr-10
                    md:max-w-80
                    lg:mr-20
                    lg:max-w-full"
                  height="450"
                  overflow="visible"
                  viewBox="0 0 462 450"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M391.703 84.0527C477.211 155.803 485.706 286.454 410.676 375.87C335.647 465.287 142.389 515.647 56.8809 443.897C-28.6272 372.147 -9.635 136.253 65.3944 46.8366C140.424 -42.58 306.195 12.3029 391.703 84.0527Z"
                    fill="#F0EFF4"
                  />
                </svg>
              </div>
            </div>
            <div className="flex-1 text-center"></div>
          </div>
        </div>
      </FullScreenContainer>
      <FullScreenContainer
        centerContent={true}
        className="relative bg-center bg-no-repeat"
        style={parallaxStyle}
      >
        <div className="mb-20 flex w-full flex-col items-center text-center font-sans">
          <div className="-mt-10">
            <svg
              className="w-full"
              width="2000"
              height="217"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1940 -0.000852894L0 -0.000852894V179.287C90.5168 181.526 147.247 192.939 195.413 202.63C276.287 218.901 333.017 230.315 485 185.285C546.02 167.206 591.686 150.899 629.725 137.315C742.855 96.9159 788.52 80.6084 970 113.437C1029.36 124.176 1074.19 133.779 1111.61 141.792C1227.03 166.516 1271.86 176.118 1455 157.305C1533.2 149.272 1586.18 139.686 1630.21 131.721C1722.72 114.983 1775.7 105.398 1940 132.393L1940 -0.000852894Z"
                fill="#5C9987"
              />
            </svg>
          </div>
          <h2
            className="ml-[10%] mt-20 w-[60%] self-start text-left text-3xl text-[#929ED8]
                        sm:text-3xl
                        md:text-4xl
                        lg:text-6xl
                        xl:text-6xl
                        "
          >
            Alle Module perfekt für den Schulalltag ausgeleg.{" "}
          </h2>
          <p
            className="mb-20 ml-[10%] mt-5 w-[60%] self-start text-left text-lg text-[#6C6C6C]
                        sm:text-base
                        md:text-lg
                        lg:text-xl
                        xl:text-xl
                        "
          >
            Die Module von Nidesso unterstützen und entlasten Sie bei sämtlichen
            Tätigkeiten rund um das Vertretungsmanagement.
          </p>
          <div
            className="flex w-full flex-col rounded-3xl  bg-[#D8DDF7] p-4 pt-20
                      sm:w-[90%]
                      md:w-[90%]
                      lg:w-[90%]
                      xl:w-[80%]
                      "
          >
            <div
              id="ausfallerfassung"
              className="mb-28 mr-0 inline-flex w-full items-start justify-normal self-center rounded-3xl bg-[#6BA796] p-8 shadow-xl
                            sm:mr-0
                            sm:w-full
                            sm:justify-normal
                            md:mr-0
                            md:w-full
                            md:justify-normal
                            lg:mr-20
                            lg:w-3/4
                            lg:justify-end 
                            lg:self-end
                            xl:mr-20
                            xl:w-3/4
                            xl:justify-end
                            xl:self-end
                            "
            >
              <div
                className="ml-0 flex w-auto flex-col
                            sm:ml-0
                            sm:flex-col
                            md:ml-0
                            md:flex-col
                            lg:-ml-40
                            lg:flex-row
                            lg:flex-wrap
                            xl:-ml-40
                            xl:flex-row
                            xl:flex-wrap
                            "
              >
                <h2
                  className="ml-0 flex w-full justify-center p-4 text-2xl font-bold  text-[#FFFFFF]
                            sm:ml-0
                            sm:w-full
                            sm:justify-center
                            sm:text-4xl
                            md:ml-0
                            md:w-full
                            md:justify-center
                            md:text-4xl
                            lg:ml-32
                            lg:w-[30%]
                            lg:justify-start
                            lg:text-3xl
                            xl:ml-0
                            xl:w-3/5
                            xl:justify-end
                            xl:text-3xl
                            "
                >
                  Ausfallerfassung
                </h2>
                <div className=" w-2/5"></div>
                <div
                  className="h-3/4 w-full
                            sm:w-full
                            md:w-full
                            lg:w-3/5
                            xl:w-3/5
                            "
                >
                  <AutoPlayVideo url="https://player.vimeo.com/video/957697215?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"></AutoPlayVideo>
                </div>
                <div
                  className="h-3/4 w-full flex-col p-4 text-center 
                            sm:w-full
                            sm:text-center
                            md:w-full
                            md:text-center
                            lg:w-2/5
                            lg:text-left
                            xl:w-2/5
                            xl:text-left  
                            "
                >
                  <h2
                    className="mb-4 mt-4 text-lg text-[#FFFFFF]
                            sm:text-lg
                            md:text-lg
                            lg:text-xl
                            xl:text-2xl
                  
                            "
                  >
                    Ausfallerfassung ganz einfach
                  </h2>
                  <p
                    className=" text-sm text-[#FFFFFF]
                            sm:text-sm
                            md:text-sm
                            lg:text-sm
                            xl:text-base
                            "
                  >
                    Sowohl Lehrkräfte als auch die Schulverwaltung können
                    Ausfälle mühelos und in wenigen Sekunden erfassen. Der
                    einheitliche Erfassungsprozess stellt sicher, dass alle
                    relevanten Informationen vollständig sind und die Erfassung
                    auch bei seltener Nutzung problemlos abläuft. Nidesso
                    ermöglicht eine flexible Anpassung an Abweichungen vom
                    regulären Stundenplan und das Hinzufügen bereits
                    organisierter Vertretungen mit nur wenigen Klicks.
                  </p>
                  <Button
                    className="mx-auto mt-4 block"
                    theme="primary"
                    onClick={() => {
                      window.location.href = "mailto:info@nidesso.ch";
                    }}
                  >
                    Demo vereinbaren!
                  </Button>
                </div>
              </div>
            </div>

            <div
              id="vertretungsmoderator"
              className="mb-28 mr-0 inline-flex w-full items-start justify-normal self-center rounded-3xl bg-[#929ED8] p-8 shadow-xl
                            sm:mr-0
                            sm:w-full
                            sm:justify-normal
                            md:mr-0
                            md:w-full
                            md:justify-normal
                            lg:ml-20
                            lg:w-3/4
                            lg:justify-start 
                            lg:self-start
                            xl:ml-20
                            xl:w-3/4
                            xl:justify-start
                            xl:self-start
                            "
            >
              <div
                className="ml-0 flex w-auto flex-col
                            sm:ml-0
                            sm:flex-col
                            md:ml-0
                            md:flex-col
                            lg:-mr-40
                            lg:flex-row
                            lg:flex-wrap
                            xl:-mr-40
                            xl:flex-row
                            xl:flex-wrap
                            "
              >
                <div className=" w-2/5"></div>
                <h2
                  className="order-1 flex w-full justify-center p-4 text-2xl font-bold text-[#FFFFFF]
                            sm:order-1
                            sm:w-full
                            sm:justify-center
                            sm:text-4xl
                            md:order-1
                            md:w-full
                            md:justify-center
                            md:text-4xl
                            lg:order-2
                            lg:w-[43%]
                            lg:justify-end
                            lg:text-3xl
                            xl:order-2
                            xl:w-3/5
                            xl:justify-start
                            xl:text-3xl
                            "
                >
                  Vertretungsmoderator
                </h2>
                <div
                  className="order-3 h-3/4 w-full flex-col p-4 text-center
                            sm:w-full
                            sm:text-center
                            md:w-full
                            md:text-center
                            lg:w-2/5
                            lg:text-right
                            xl:w-2/5
                            xl:text-right  
                            "
                >
                  <h2
                    className="mb-4 mt-4 text-lg text-[#FFFFFF]
                            sm:text-lg
                            md:text-lg
                            lg:text-xl
                            xl:text-2xl
                  
                            "
                  >
                    Kurzfristige Ausfälle reibungslos intern besetzen
                  </h2>
                  <p
                    className=" text-sm text-[#FFFFFF]
                            sm:text-sm
                            md:text-sm
                            lg:text-sm
                            xl:text-base
                            "
                  >
                    Mit dem Vertretungsmoderator von Nidesso gehören
                    zeitaufwendige Kommunikations- und Koordinationsaufgaben bei
                    kurzfristigen Ausfällen der Vergangenheit an. Sobald ein
                    Ausfall erfasst wird, informiert der Moderator automatisch
                    alle betroffenen verfügbaren Lehrpersonen. Angefragte
                    Lehrkräfte können mühelos einsehen, welche Lektionen bereits
                    abgedeckt sind und sich unkompliziert für noch offene
                    Lektionen bewerben. Erleben Sie eine nahtlose und effiziente
                    Kommunikation, die Ihren Arbeitsalltag erheblich
                    erleichtert.
                  </p>
                  <Button
                    className="mx-auto mt-4 block"
                    theme="primary"
                    onClick={() => {
                      window.location.href = "mailto:info@nidesso.ch";
                    }}
                  >
                    Demo vereinbaren!
                  </Button>
                </div>
                <div
                  className="order-2 h-3/4 w-full
                            sm:order-2
                            sm:w-full
                            md:order-2
                            md:w-full
                            lg:order-4
                            lg:w-3/5
                            xl:order-4
                            xl:w-3/5
                            "
                >
                  <AutoPlayVideo url="https://player.vimeo.com/video/992230479?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"></AutoPlayVideo>
                </div>
              </div>
            </div>

            <div
              id="vertretungsmanager"
              className="mb-28 mr-0 inline-flex w-full items-start justify-normal self-center rounded-3xl bg-[#6BA796] p-8 shadow-xl
                            sm:mr-0
                            sm:w-full
                            sm:justify-normal
                            md:mr-0
                            md:w-full
                            md:justify-normal
                            lg:mr-20
                            lg:w-3/4
                            lg:justify-end 
                            lg:self-end
                            xl:mr-20
                            xl:w-3/4
                            xl:justify-end
                            xl:self-end
                            "
            >
              <div
                className="ml-0 flex w-auto flex-col
                            sm:ml-0
                            sm:flex-col
                            md:ml-0
                            md:flex-col
                            lg:-ml-40
                            lg:flex-row
                            lg:flex-wrap
                            xl:-ml-40
                            xl:flex-row
                            xl:flex-wrap
                            "
              >
                <h2
                  className="ml-0 flex w-full justify-center p-4 text-2xl font-bold text-[#FFFFFF]
                            sm:ml-0
                            sm:w-full
                            sm:justify-center
                            sm:text-4xl
                            md:ml-0
                            md:w-full
                            md:justify-center
                            md:text-4xl
                            lg:ml-32
                            lg:w-[30%]
                            lg:justify-start
                            lg:text-3xl
                            xl:ml-0
                            xl:w-3/5
                            xl:justify-end
                            xl:text-3xl
                            "
                >
                  Vertretungsmanager
                </h2>
                <div className=" w-2/5"></div>
                <div
                  className="h-3/4 w-full
                            sm:w-full
                            md:w-full
                            lg:w-3/5
                            xl:w-3/5
                            "
                >
                  <AutoPlayVideo url="https://player.vimeo.com/video/992991092?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"></AutoPlayVideo>
                </div>
                <div
                  className="h-3/4 w-full flex-col p-4 text-center 
                            sm:w-full
                            sm:text-center
                            md:w-full
                            md:text-center
                            lg:w-2/5
                            lg:text-left
                            xl:w-2/5
                            xl:text-left  
                            "
                >
                  <h2
                    className="mb-4 mt-4 text-lg text-[#FFFFFF]
                            sm:text-lg
                            md:text-lg
                            lg:text-xl
                            xl:text-2xl
                  
                            "
                  >
                    Jederzeit den Überblick und die Kontrolle
                  </h2>
                  <p
                    className=" text-sm text-[#FFFFFF]
                            sm:text-sm
                            md:text-sm
                            lg:text-sm
                            xl:text-base
                            "
                  >
                    Mit der Vertretungsverwaltung erhalten Sie einen umfassenden
                    Überblick über all ihre Vertretungsstellen und Anfragen in
                    Echtzeit. Nutzen Sie die intuitive Benutzeroberfläche, um
                    Vertretungslehrpersonen mühelos zu koordinieren – lehnen Sie
                    Anfragen ab, nehmen Sie sie an oder weisen Sie selbst
                    passende Vertretungslehrpersonen ausfallenden Lektionen zu.
                    <br></br>Unser Modul bietet Ihnen zudem die Möglichkeit,
                    Vertretungsstellen flexibel zu bearbeiten. Mit nur wenigen
                    Klicks behalten Sie stets den Überblick und sorgen für einen
                    reibungslosen Ablauf. Erleben Sie, wie einfach und effizient
                    die Verwaltung von Vertretungen sein kann – mit unserer
                    massgeschneiderten Softwarelösung.
                  </p>
                  <Button
                    className="mx-auto mt-4 block"
                    theme="primary"
                    onClick={() => {
                      window.location.href = "mailto:info@nidesso.ch";
                    }}
                  >
                    Demo vereinbaren!
                  </Button>
                </div>
              </div>
            </div>

            <div
              id="vermittlungsplattform"
              className="mb-28 mr-0 inline-flex w-full items-start justify-normal self-center rounded-3xl bg-[#929ED8] p-8 shadow-xl
                            sm:mr-0
                            sm:w-full
                            sm:justify-normal
                            md:mr-0
                            md:w-full
                            md:justify-normal
                            lg:ml-20
                            lg:w-3/4
                            lg:justify-start 
                            lg:self-start
                            xl:ml-20
                            xl:w-3/4
                            xl:justify-start
                            xl:self-start
                            "
            >
              <div
                className="ml-0 flex w-auto flex-col
                            sm:ml-0
                            sm:flex-col
                            md:ml-0
                            md:flex-col
                            lg:-mr-40
                            lg:flex-row
                            lg:flex-wrap
                            xl:-mr-40
                            xl:flex-row
                            xl:flex-wrap
                            "
              >
                <div className=" -ml-8 mr-8 flex w-2/5 items-center justify-start">
                  <p
                    className="rounded-br-3xl rounded-tr-3xl bg-[#FE9456] pb-4 pl-8 pr-8 pt-4 text-xl text-[#ffffff]
                            sm:w-full
                            md:w-full
                            lg:w-2/3
                            xl:w-2/3
                            "
                  >
                    Bald verfügbar!
                  </p>
                </div>
                <h2
                  className="order-1 flex w-full justify-center p-4 text-2xl font-bold text-[#FFFFFF]
                            sm:order-1
                            sm:w-full
                            sm:justify-center
                            sm:text-4xl
                            md:order-1
                            md:w-full
                            md:justify-center
                            md:text-4xl
                            lg:order-2
                            lg:w-[44%]
                            lg:justify-end
                            lg:text-3xl
                            xl:order-2
                            xl:w-3/5
                            xl:justify-start
                            xl:text-3xl
                            "
                >
                  Vermittlungsplattform
                </h2>
                <div
                  className="order-3 h-3/4 w-full flex-col p-4 text-center
                            sm:w-full
                            sm:text-center
                            md:w-full
                            md:text-center
                            lg:w-2/5
                            lg:text-right
                            xl:w-2/5
                            xl:text-right  
                            "
                >
                  <h2
                    className="mb-4 mt-4 text-lg text-[#FFFFFF]
                            sm:text-lg
                            md:text-lg
                            lg:text-xl
                            xl:text-2xl
                  
                            "
                  >
                    Erhöhe deine Reichweite für die perfekte Vertretung
                  </h2>
                  <p
                    className=" text-sm text-[#FFFFFF]
                            sm:text-sm
                            md:text-sm
                            lg:text-sm
                            xl:text-base
                            "
                  >
                    Haben Sie intern keine Vertretung ausfindig gemacht? Kein
                    Problem. Mit unserer Vermittlungsplattform ist Ihre Schule
                    Teil eines umfangreichen Netzwerks von Schulen, die
                    gemeinsam mit Nidesso für ein kontinuierliches Angebot an
                    externen Vertretungslehrpersonen sorgen.
                    <br></br>Schreiben Sie Ihre Vertretungsstelle einfach mit
                    wenigen Klicks aus und vergleichen Sie Ihre Bewerber:innen
                    anhand aussagekräftigen Profilen, um die beste verfügbare
                    Wahl ausfindig zu machen. <br></br>Vertretungssuche war noch
                    nie so einfach!
                  </p>
                  <Button
                    className="mx-auto mt-4 block"
                    theme="primary"
                    onClick={() => {
                      window.location.href = "mailto:info@nidesso.ch";
                    }}
                  >
                    Demo vereinbaren!
                  </Button>
                </div>
                <div
                  className="order-2 h-3/4 w-full
                            sm:order-2
                            sm:w-full
                            md:order-2
                            md:w-full
                            lg:order-4
                            lg:w-3/5
                            xl:order-4
                            xl:w-3/5
                            "
                >
                  <div className="h-full w-full flex-col rounded-xl bg-[#F0EFF4] shadow-xl">
                    <div className="h-1/6 w-full rounded-tl-xl rounded-tr-xl border-b-2 border-b-gray-200 bg-[#FFFFFF]">
                      <svg
                        className="ml-2"
                        width="80"
                        height="18"
                        viewBox="0 0 203 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="17.5" cy="17.5" r="17.5" fill="#5C9987" />
                        <circle cx="101.5" cy="17.5" r="17.5" fill="#F3A42E" />
                        <circle cx="185.5" cy="17.5" r="17.5" fill="#FF7676" />
                      </svg>
                    </div>
                    <div className="flex h-full w-full flex-col items-center justify-center">
                      <img
                        className="z-10 mb-20 mt-20 w-1/2"
                        src={conn}
                        alt="Erhöhung der Reichweite"
                      />
                      <svg
                        className="absolute mr-6 w-[40%] -rotate-90
                            sm:w-[40%]
                            md:w-[40%]
                            lg:w-[27%]
                            xl:w-[20%]"
                        overflow="visible"
                        viewBox="0 0 462 450"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        "
                        <path
                          d="M391.703 84.0527C477.211 155.803 485.706 286.454 410.676 375.87C335.647 465.287 142.389 515.647 56.8809 443.897C-28.6272 372.147 -9.635 136.253 65.3944 46.8366C140.424 -42.58 306.195 12.3029 391.703 84.0527Z"
                          fill="#D8DDF7"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FullScreenContainer>
    </>
  );
}

export default Home;
